import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  FaUsers,
  FaProductHunt,
  FaHome,
  FaCogs,
  FaAd,
  FaList,
  FaMoneyCheck,
  FaShoppingBag,
} from 'react-icons/fa';

import SideBarMenuItem from './SideBarMenuItem';
import DropDown from './DropDownMenu';
import DropDownItem from './DropDownItem';

// eslint-disable-next-line react/prop-types
const SideBar = ({ intl, path, user }) => {
  if (path === '/login') {
    return null;
  }
  return (
    <Wrapper>
      <Brand>
        <BrandLink to="/">
          SambaPOS Go Tablet Office
        </BrandLink>
      </Brand>
      <MenuWrapper>
        {
          user && !user.isAdmin ? (
            <div>
              <SideBarMenuItem icon={FaHome} to="/panel" title={intl.formatMessage({ id: 'sidebar.menu.home' })} />
              <DropDown title={intl.formatMessage({ id: 'sidebar.menu.product' })} icon={<FaProductHunt />}>
                <DropDownItem to="/panel/product-list" title={intl.formatMessage({ id: 'productList.title' })} />
                <DropDownItem to="/panel/product-sorting" title={intl.formatMessage({ id: 'productSorting.title' })} />
              </DropDown>
            </div>
          ) : (
              <div>
                <SideBarMenuItem icon={FaHome} to="/panel" title={intl.formatMessage({ id: 'sidebar.menu.home' })} />
                <SideBarMenuItem icon={FaList} to="/panel/menu-edit" title={intl.formatMessage({ id: 'sidebar.menu.edit' })} />
                <SideBarMenuItem icon={FaProductHunt} to="/panel/product-sorting" title={intl.formatMessage({ id: 'productSorting.title' })} />
                <DropDown title={intl.formatMessage({ id: 'sidebar.menu.adsSettings' })} icon={<FaAd />}>
                  
                  <DropDownItem to="/panel/home-ads" title={intl.formatMessage({ id: 'sidebar.menu.homeAds' })} />
                </DropDown>
                <DropDown title={intl.formatMessage({ id: 'sidebar.menu.settings' })} icon={<FaCogs />}>
                  <DropDownItem to="/panel/settings" title={intl.formatMessage({ id: 'sidebar.menu.general' })} />
                  <DropDownItem to="/panel/color-settings" title={intl.formatMessage({ id: 'sidebar.menu.theme' })} />
                  <DropDownItem to="/panel/languages" title={intl.formatMessage({ id: 'sidebar.menu.languages' })} />
                </DropDown>
              </div>
            )
        }
      </MenuWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  width: 250px;
  background: #1e1e2d;
  position:fixed;
  z-index: 1;
  top: 56;
  left: 0;
  @media (min-width: 320px) and (max-width: 480px) {
    visibility: hidden;
    opacity: 0;
  }
`;
const Brand = styled.div`
  height: 65px;
  background-color: #1a1a27;
  padding: 10px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BrandLink = styled(Link)`
  color: white;
  text-decoration: none !important;
  font-weight: 700;
  font-size: 1.4rem;
  :hover {
    color: white;
  }
`;
const MenuWrapper = styled.ul`
  padding-left: 0;
  padding-top: 30px;
`;

const mapStateToProps = (state) => ({
  path: state.router.location.pathname,
  user: state.auth.user,
});

export default injectIntl(connect(mapStateToProps)(SideBar));
